/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AromasInputs */

const en_aromas = /** @type {(inputs: AromasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aromas`)
};

const es_aromas = /** @type {(inputs: AromasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aromas`)
};

/**
* | output |
* | --- |
* | "Aromas" |
*
* @param {AromasInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const aromas = /** @type {((inputs?: AromasInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AromasInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aromas(inputs)
	return es_aromas(inputs)
});